export default "__VITE_ASSET__bb95c995__"